import { faLanguage } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import VoxelAlert from '../../voxel/Alert/VoxelAlert';
import VoxelDialog from '../../voxel/Dialogs/VoxelDialog';
import VoxelDialogActionSubmit from '../../voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../voxel/Dialogs/VoxelDialogContent';
import TranslateProjectForm from '../Forms/TranslateProjectForm/TranslateProjectForm';
import { useTranslateProjectForm } from '../Forms/TranslateProjectForm/useTranslateForm';

export interface TrnslateProjectDialogProps {
  close: () => void;
  project: ProjectGq;
  onSuccess: (id: ProjectGq) => Promise<void>;
  user: CurrentUserGq;
}

const TranslateProjectDialog: React.FC<TrnslateProjectDialogProps> = ({
  close,
  project,
  onSuccess,
  user,
}) => {
  const formBag = useTranslateProjectForm(project, onSuccess, user);

  const handleClose = () => {
    formBag.resetForm();
    close();
  };
  return (
    <VoxelDialog
      title="Translate project"
      subtitle="The following action creates a new project and fetches keyword data in the new language/location."
      open={true}
      closeOnBackdrop
      onClose={handleClose}
    >
      <VoxelDialogContent classMinWidth="min-w-[700px]">
        <TranslateProjectForm formBag={formBag} user={user} />
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionSubmit
          title="Translate project"
          onClick={formBag.submitForm}
          endIcon={<FontAwesomeIcon icon={faLanguage} size="lg" />}
          disabled={!formBag.isValid || formBag.isSubmitting || !formBag.values.fromLanguage}
        />
      </VoxelDialogActions>
      {!formBag.values.fromLanguage && (
        <div className="w-full mb-2">
          <VoxelAlert iconSize="lg" severity="error" roundedClass="rounded-tl-none rounded-tr-none">
            This feature is only available for projects with an orginal language.
          </VoxelAlert>
        </div>
      )}
    </VoxelDialog>
  );
};

export default TranslateProjectDialog;
